<form [formGroup]="form.formGroup">
  <div class="flex flex-col space-y-2">
    
    <app-general-epp
      [formControlName]="form.formControlNames.generalEpp"
      [currentString]="currentString"
      [userUnits]="userUnits"
      [loadCaseIndex]="loadCaseIndex"
    ></app-general-epp>

    <div class="flex flex-col">
      <label>Cement Mix-Water Density</label>
      <app-validated-number-input
        [id]="'cementMixwaterDensity'"
        [control]="control('cementMixwaterDensity')"
        [value]="control('cementMixwaterDensity').value"
        [validation]="densityValidation"
        [unit]="densityLabel"
      ></app-validated-number-input>
    </div>

    <p class="text-sm">
      Mud Weight: &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
      {{ currentString?.annularFluid.state.nominalDensity.toFixed(2) }}
      {{ densityLabel }}
    </p>

    <p class="text-sm">
      Top Of Cement: &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
      {{ currentString?.topOfCementMd.toFixed(2) }} {{ userUnits.longLengths }}
    </p>

  </div>
</form>
